import { Component, OnInit, ViewChild } from '@angular/core';
import { NavController, NavParams, ModalController, List } from 'ionic-angular';
import { WelcomePage } from "../welcome/welcome";
import { AuthProvider } from "../../providers/authservice/auth";
import { AngularFireDatabase } from "angularfire2/database";
//import { AngularFireOfflineDatabase } from "angularfire2-offline";
import { SmartanimationProvider } from "../../providers/smartanimation/smartanimation";
import { HomePage } from "../home/home";
import { RestaurantslistPage } from "../restaurantslist/restaurantslist";
import { CustomepopupComponent } from "../../components/customepopup/customepopup";

@Component({
  selector: 'page-opentables',
  templateUrl: 'opentables.html',
})
export class OpenTablesPage {

  @ViewChild('divAnimate') divAnimate;
  //  restKey: string;
  listData: Array<any> = new Array<any>();
  listServers: any = [];
  isLoading: boolean = true;
  tableId: string;
  server: any;
  isConnected: boolean = false;
  restData: any;
  searchWaiter = "";

  constructor(

    // Services
    public navCtrl: NavController,
    public navParams: NavParams,
    public af: AngularFireDatabase,
    public openModel: ModalController,
    public animateService: SmartanimationProvider
  ) {
    // Constructor Function
    console.log('Animation Loading');

    this.isLoading = true;
    this.server = JSON.parse(localStorage.getItem('server'));
    this.isConnected = this.server != undefined;
    this.af.object('restaurants/-1').valueChanges().subscribe(t => {
      this.restData = t;
      this.restData.key = -1;
    });

    this.af.list('users/', ref => {
      let obj = ref.orderByChild('waiterTo').equalTo('-1');
      return obj;
    }).snapshotChanges().map(changes => {
      return changes.map(c => ({ userUID: c.payload.key, ...c.payload.val() }));
    }).subscribe((res) => {
      console.log(res);
      let j = 0;
      let obj: any;
      for (let i = 0; i < res.length; i++) {
        if ((res[i] as any).isAvailable) {
          obj = res[i];
          obj.connected = this.server ? this.server.userUID == res[i].userUID : false;
          this.listData.push(obj);
          this.listServers[j] = obj;
          j++;
        }
      }
      console.log(this.listServers);
      //  this.listServers = res;
      this.isLoading = false;
    });
  }

  ionViewWillEnter() {
    this.animateService.smartAnimation().setType('fadeIn').show(this.divAnimate.nativeElement);
  }

  alertModel(server) {
    if (this.isConnected)
      return;
    console.log(server);
    let alertModal = this.openModel.create(CustomepopupComponent, { server: server, tableId: this.tableId, resturenData: this.restData });
    alertModal.present();
  }

  navigate() {
    this.navCtrl.setRoot(HomePage, { server: this.server, resturenData: this.restData });
  }

  connect() {
    this.navCtrl.pop();
  }

  goToRestaurantlistPage() {
    this.navCtrl.setRoot(RestaurantslistPage, { initiator: 'opentable' });
  }

  welcomePage() {
    this.navCtrl.setRoot(WelcomePage, { initiator: 'opentable' });
  }

  filterWaiters(event) {
    console.log(event);
    var q = event.target.type === 'search' ? event.target.value : '';
    this.listData.forEach(function (obj) { obj.added = false; })
    this.listServers = this.listData.filter((v) => {
      if (!v.added && (v.fullname.toLowerCase().indexOf(q.toLowerCase()) > -1 || v.email.toLowerCase().indexOf(q.toLowerCase()) > -1 || (v.resName && v.resName.toLowerCase().indexOf(q.toLowerCase()) > -1))) {
        v.added = true;
        return true;
      }
      return false;
    })

    //searchWaiter
  }
}



// WEBPACK FOOTER //
// ./src/pages/opentables/opentables.ts